import { Component, EventEmitter, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-expired-subscription-error-modal",
  templateUrl: "./expired-subscription-error-modal.component.html",
  styleUrls: ["./expired-subscription-error-modal.component.scss"],
})
export class ExpiredSubscriptionErrorModalComponent {
  @Output() close = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.ExpiredSubscriptionError;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }
}
